import { render, staticRenderFns } from "./SchulteForm.vue?vue&type=template&id=71b86ced&scoped=true&lang=pug&"
import script from "./SchulteForm.vue?vue&type=script&lang=js&"
export * from "./SchulteForm.vue?vue&type=script&lang=js&"
import style0 from "./SchulteForm.vue?vue&type=style&index=0&id=71b86ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b86ced",
  null
  
)

export default component.exports